enum Method {
	POST = "POST",
	GET = "GET",
}

export default Method;
